import { Mode } from "@/components/common/enroll-now-dialog";
import { api } from "./fetch";
import {
  ApplyCouponParams,
  CartCustomerAndOrderResponse,
  CartResponse,
  ChangeQuantityParams,
  GetCartItemParams,
  GetCustomerParams,
  OrderResponse,
  RemoveCartParams,
} from "@/types/cart";
import { objectToQueryParams } from "@/helpers/obj-to-query-params";

export interface AddCartPayload {
  couponCode?: string;
  countryCode: string;
  guestUserId?: string;
  serviceId: number;
  eventId: number;
  offerId: number | null;
  eventDetailId: number;
  quantity: number;
  mode?: Mode;
}

export const cartService = {
  getCart(params: GetCartItemParams) {
    const queryString = objectToQueryParams(params);
    return api<CartResponse>(`/get-cart-item?${queryString}`);
  },

  getCustomerAndOrder(params: GetCustomerParams) {
    return api<CartCustomerAndOrderResponse>(
      `/get-cart-customer-and-order?cartId=${params.cartId}`
    );
  },

  addToCart(payload: AddCartPayload) {
    return api("/add-cart-item", {
      method: "POST",
      body: JSON.stringify(payload),
    });
  },
  changeQuantity(payload: ChangeQuantityParams) {
    return api("/change-cart-quantity", {
      method: "PUT",
      body: JSON.stringify(payload),
    });
  },

  removeCart(payload: RemoveCartParams) {
    return api("/remove-cart-item", {
      method: "DELETE",
      body: JSON.stringify(payload),
    });
  },

  applyCoupon(params: ApplyCouponParams) {
    return api("/apply-coupon", {
      method: "POST",
      body: JSON.stringify(params),
    });
  },

  removeCoupon(params: ApplyCouponParams) {
    return api("/remove-coupon", {
      method: "POST",
      body: JSON.stringify(params),
    });
  },
  getOrderById(orderId: string) {
    return api<OrderResponse>(`/order/${orderId}`);
  },
  resendProformaInvoice(params: { order_id: string | number }) {
    return api<{ success: boolean; message: string }>(`/resend-proforma-invoice`, {
      method: "POST",
      body: JSON.stringify(params),
    });
  },
  retriveCheckoutSession(sessionId: string) {
    return api<any>(`/session-retrieve?session_id=${sessionId}`);
  },

  checkout(payload: any) {
    return api("/checkout", {
      method: "POST",
      body: JSON.stringify(payload),
    });
  },
};
